import { registerQuery } from 'data-fetching-client';
import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GET_REVIEWABILITY = registerQuery({
  fieldName: 'reviewability',
  fetcher: queries => ecosystemAppClient.post(`reviews/reviewability/check`, {
    data: Object.assign({}, queries)
  })
});